'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import { memo } from 'react';

import staticApiMainAnimation from '@/assets/lottie/static-api/staticApiMainAnimation.json';
import { useGetClientHost } from '@/shared/hooks';
import { classNames } from '@/shared/lib/classNames/classNames';
import { Domain } from '@/shared/types';
import { LottieAnimation } from '@/shared/ui/lottie';
import { getDomainKey, isRuDomain } from '@/shared/utils/getDomainInfo';

interface MainScreenByDomainProps {
  imagesByDomain: Partial<Record<Domain, AppImageData>>;
  className?: string;
  contentClassName?: string;
}

export const MainScreenByDomain = memo(
  ({
    imagesByDomain,
    className,
    contentClassName,
  }: MainScreenByDomainProps) => {
    const clientHost = useGetClientHost();

    return isRuDomain(
      clientHost,
    ) /** Анимация в полупрозрачном блоке для мобильных */ ? (
      <LottieAnimation
        animationData={staticApiMainAnimation}
        className={className}
        lottieClassName={contentClassName}
        loop
        autoplay
      />
    ) : (
      <ImageByDomain
        imagesByDomain={imagesByDomain}
        className={className}
        contentClassName={contentClassName}
      />
    );
  },
);

MainScreenByDomain.displayName = 'MainScreenByDomain';

const ImageByDomain = memo(
  ({
    imagesByDomain,
    className,
    contentClassName,
  }: MainScreenByDomainProps) => {
    const domain = getDomainKey(useGetClientHost());
    const imageData = imagesByDomain[domain];

    if (!imageData) {
      return null;
    }

    return (
      <div className={className}>
        <AppImageClient
          {...imageData}
          alt="Пример карты Static API"
          className={classNames({
            cls: 'size-full',
            additional: [contentClassName],
          })}
        />
      </div>
    );
  },
);

ImageByDomain.displayName = 'ImageByDomain';
